import { registerAreamap } from './register-areamap';
import { registerScattermap } from './register-scattermap';

let mapsRegistered = false;

export const registerMaps = () => {
  if (mapsRegistered) {
    return;
  }
  mapsRegistered = true;
  registerScattermap();
  registerAreamap();
};

registerMaps();
